import { HTMLAttributes, useRef } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { Heading } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
  defaultOpen?: boolean;
  alignStart?: boolean;
}

export function Accordion({
  title,
  children,
  defaultOpen = false,
  alignStart = false,
  ...rest
}: Props) {
  const toggleAccordion = useRef<HTMLInputElement>(null);

  function toggleOpenState() {
    const { current } = toggleAccordion;

    if (!current) return;

    current.checked = !current.checked;
  }

  return (
    <>
      <S.ToggleCheckbox
        ref={toggleAccordion}
        type="checkbox"
        hidden
        defaultChecked={defaultOpen}
      />

      <S.Main {...rest}>
        <S.Wrapper
          type="button"
          onClick={toggleOpenState}
          $alignStart={alignStart}
        >
          <S.ToggleIcon>
            <IoIosArrowDown />
          </S.ToggleIcon>

          <Heading size={FontSize.font16} weight={FontWeight.bold}>
            {title}
          </Heading>
        </S.Wrapper>

        <S.ContentWrapper>{children}</S.ContentWrapper>
      </S.Main>
    </>
  );
}
